var _path, _g, _path2, _g2, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#208a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "209b",
    width: 22,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#209b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.905 0H2.095C.938 0 0 .955 0 2.133v11.734C0 15.045.938 16 2.095 16h17.81C21.062 16 22 15.045 22 13.867V2.133C22 .955 21.062 0 19.905 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#150A99",
    fillRule: "evenodd",
    d: "M0 10.668h22v5.333H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    d: "M0 0h22v5.333H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0091E0",
    fillRule: "evenodd",
    d: "M8.38 4.266h1.048v1.067H8.381zm2.096-1.067h1.048v2.134h-1.048zm2.095 1.067h1.048v1.067h-1.048z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#150A99",
    fillRule: "evenodd",
    d: "M11.524 3.2h1.048v2.133h-1.048zm-2.095 0h1.047v2.133H9.43z",
    clipRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "210c",
    width: 6,
    height: 7,
    x: 8,
    y: 5,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.619 9.065c0 1.472-1.173 2.667-2.62 2.667-1.445 0-2.618-1.195-2.618-2.667V5.332h5.238z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#210c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M13.619 9.065c0 1.472-1.173 2.667-2.62 2.667-1.445 0-2.618-1.195-2.618-2.667V5.332h5.238z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.428 10.665h1.048v1.067H9.428zm2.096 0h1.047v1.067h-1.047zM10.476 9.6h1.048v1.066h-1.048zM9.428 8.532h1.048v1.067H9.428zm2.096 0h1.047v1.067h-1.047zm-1.048-1.067h1.048v1.067h-1.048zM9.428 6.4h1.048v1.066H9.428zm2.096 0h1.047v1.066h-1.047zm-1.048-1.067h1.048v1.067h-1.048zm2.095 0h1.048v1.067h-1.048zm0 2.133h1.048v1.067h-1.048zm0 2.134h1.048v1.066h-1.048zm-4.19 0h1.047v1.066H8.381zm0-2.134h1.047v1.067H8.381zm0-2.133h1.047v1.067H8.381z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M19.905.535H2.095c-.868 0-1.571.717-1.571 1.6V13.87c0 .883.703 1.6 1.571 1.6h17.81c.868 0 1.571-.717 1.571-1.6V2.134c0-.883-.703-1.6-1.571-1.6Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "208a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v16H0z"
  })))));
});
const SvgFlagHr = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlagHr);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,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";